import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { APIProvider, AdvancedMarker, Map as GoogleMap, useAdvancedMarkerRef, useMap } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";
import { getGoogleMapsApiKey } from "../../lib/getEnvVariables";
const API_KEY = getGoogleMapsApiKey();
const DEFAULT_MAP_CENTER = { lat: 22.54992, lng: 0 };
const DEFAULT_MAP_ZOOM = 1.95;
const MAP_ID = "1";
const GEOCODE_STATUS_OK = "OK";
const MIN_ADDRESS_COMPONENTS = 1;
const ADDRESS_START_SLICE = 1;
const GoogleMapLocator = ({ selectedPlace, setSelectedPinInfo }) => {
    const [markerRef, marker] = useAdvancedMarkerRef();
    const [latLangBounds, setLatLangBounds] = useState(null);
    useEffect(() => {
        if (selectedPlace) {
            setLatLangBounds(null);
        }
    }, [selectedPlace]);
    const getFormattedAddress = (geoCodes) => {
        if (geoCodes && geoCodes.length > 0) {
            const addressList = geoCodes.filter((geoCode) => geoCode?.address_components?.length > MIN_ADDRESS_COMPONENTS && geoCode?.formatted_address);
            const formattedAddress = addressList?.[0]?.formatted_address || null;
            if (geoCodes[0].address_components.length > MIN_ADDRESS_COMPONENTS && formattedAddress !== null) {
                const addressSegments = formattedAddress?.split(" ");
                const selectedAddress = addressSegments?.slice(ADDRESS_START_SLICE, addressSegments?.length).join(" ");
                return selectedAddress;
            }
            return formattedAddress;
        }
        return null;
    };
    const onDblclickHandler = (event) => {
        if (event.detail.latLng) {
            setLatLangBounds(event.detail.latLng);
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: event.detail.latLng }, (results, status) => {
                if (status === GEOCODE_STATUS_OK) {
                    const formattedAddress = getFormattedAddress(results);
                    setSelectedPinInfo({
                        address: formattedAddress || "",
                        coordinates: {
                            lat: event.detail.latLng.lat,
                            lng: event.detail.latLng.lng
                        }
                    });
                }
                else {
                    setSelectedPinInfo({
                        address: "",
                        coordinates: {
                            lat: event.detail.latLng.lat,
                            lng: event.detail.latLng.lng
                        }
                    });
                }
            });
        }
    };
    const onDragEndHandler = (event) => {
        if (event.latLng) {
            setLatLangBounds(event.latLng);
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: event.latLng }, (results, status) => {
                if (status === GEOCODE_STATUS_OK) {
                    const formattedAddress = getFormattedAddress(results);
                    setSelectedPinInfo({
                        address: formattedAddress || "",
                        coordinates: {
                            lat: event.latLng.lat(),
                            lng: event.latLng.lng()
                        }
                    });
                }
                else {
                    setSelectedPinInfo({
                        address: "",
                        coordinates: {
                            lat: event.latLng.lat(),
                            lng: event.latLng.lng()
                        }
                    });
                }
            });
        }
    };
    return (_jsxs(APIProvider, { apiKey: API_KEY, children: [_jsx(GoogleMap, { cameraControl: false, className: "h-full", defaultCenter: DEFAULT_MAP_CENTER, defaultZoom: DEFAULT_MAP_ZOOM, gestureHandling: "greedy", mapId: MAP_ID, onDblclick: onDblclickHandler, streetViewControl: false, children: _jsx(AdvancedMarker, { draggable: true, onDragEnd: onDragEndHandler, position: null, ref: markerRef }) }), _jsx(MapHandler, { latLangBounds: latLangBounds, marker: marker, place: selectedPlace })] }));
};
const MapHandler = ({ latLangBounds, marker, place }) => {
    const map = useMap();
    useEffect(() => {
        if (latLangBounds) {
            marker.position = latLangBounds;
        }
        else {
            if (!map || !place || !marker)
                return;
            if (place.geometry?.viewport) {
                map.fitBounds(place.geometry?.viewport);
            }
            marker.position = place.geometry?.location;
        }
    }, [map, place, marker, latLangBounds]);
    return null;
};
export default GoogleMapLocator;
